export const csgo = require("./csgo_logo.png");
export const dota = require("./dota_logo.png");
export const hs = require("./hs_logo.png");
export const lol = require("./lol_logo.png");
export const ow = require("./ow_logo.png");
export const eg = require("./eg.png");
export const vp = require("./vp.png");

export const lgd = require("./lgd.png");
export const lumi = require("./lumi.png");

export const wings = require("./wings.png");
export const newbee = require("./newbee.png");
export const teamliquid = require("./teamliquid.png");



// WEBPACK FOOTER //
// ./src/assets/images/logos/index.js